import React, { useCallback, useMemo } from 'react';
import { PropTypes } from 'prop-types';

import { parseFullName } from 'utils/helpers';
import { useExportPortfolioMutation } from 'api/main';
import { listingActionButtonStyle, roleCategories, subscriptionStatus } from 'utils/constants';
import { useSmallScreen, useUserRoleMatchCategory } from 'utils/hooks';
import { texts } from 'utils/languages/fr';

import PortfolioTable from 'containers/portfolio/ProtfolioTable';
import { ActionButton, CustomDialogTitle, Loader } from 'components';
import { Box, Dialog, DialogContent } from '@mui/material';

const PortfolioDialog = ({ investor, open, onClose, loading }) => {
    const isTablet = useSmallScreen('lg');
    const userIsPromoter = useUserRoleMatchCategory(roleCategories.PROMOTERS);

    const [exportPortfolio, { isLoading: exportLoading }] = useExportPortfolioMutation();

    const investorName = useMemo(
        () =>
            investor?.subscriptions?.length && investor.subscriptions[0].role.name.includes('PP')
                ? parseFullName(investor)
                : investor?.investorCompany?.corporateName,
        [investor]
    );
    const finishedSubscriptions = useMemo(
        () =>
            investor?.subscriptions?.filter(
                s => s.subscriptionStatus === subscriptionStatus.FINISHED
            ),
        [investor]
    );

    const handleExport = useCallback(() => {
        exportPortfolio(investor.id);
    }, [exportPortfolio, investor]);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={isTablet}
            maxWidth="xl"
            onKeyDown={e => e.stopPropagation()}
        >
            <CustomDialogTitle
                title={`${texts.PORTFOLIO} - ${investorName}`}
                handleClose={onClose}
            />
            <DialogContent>
                <Loader loading={loading}>
                    <PortfolioTable hideColumns finishedSubscriptions={finishedSubscriptions} />
                    {!userIsPromoter && (
                        <Box display="flex" alignItems="center" justifyContent="flex-end">
                            <ActionButton
                                variant="outlined"
                                sx={listingActionButtonStyle}
                                onClick={handleExport}
                                loading={exportLoading}
                            >
                                {texts.EXPORT_PDF}
                            </ActionButton>
                        </Box>
                    )}
                </Loader>
            </DialogContent>
        </Dialog>
    );
};

PortfolioDialog.propTypes = {
    open: PropTypes.bool,
    loading: PropTypes.bool,
    onClose: PropTypes.func,
    investor: PropTypes.object,
};

export default PortfolioDialog;
